import React, { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router";
import { resetPasswordWithTokenService } from "@/services/authService";
import Button from "@/components/input/Button";
import Input from "@/components/input/Input";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    if (newPassword.length < 6) {
      enqueueSnackbar({
        variant: "error",
        message: "La contraseña debe tener al menos 6 caracteres.",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      enqueueSnackbar({
        variant: "error",
        message: "Las contraseñas no coinciden.",
      });
      return;
    }

    try {
      setLoading(true);
      await resetPasswordWithTokenService(token as string, newPassword);
      enqueueSnackbar({
        variant: "success",
        message: "Tu contraseña ha sido restablecida.",
      });
      navigate("/login");
    } catch (error) {
      enqueueSnackbar({
        variant: "error",
        message: "El token es inválido o ha expirado.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleResetPassword}>
        <h1 style={styles.title}>Restablecer Contraseña</h1>
        <Input
          required
          label="Nueva contraseña"
          placeholder="Escribe tu nueva contraseña"
          onChange={(e) => setNewPassword(e.target.value)}
          value={newPassword}
        />
        <Input
          required
          label="Confirmar contraseña"
          placeholder="Confirma tu nueva contraseña"
          onChange={(e) => setConfirmPassword(e.target.value)}
          value={confirmPassword}
        />
        <Button sx={styles.button} disabled={loading}>
            {loading ? "Enviando..." : "Cambiar contraseña"}
        </Button>
      </form>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 32,
    paddingRight: 32,
    position: "relative",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    width: 400,
  },
  title: {
    fontSize: 26,
    fontWeight: "bold",
    color: "#fff",
    textAlign: "center",
    marginBottom: 32,
  },
  input: {
    height: 48,
    borderWidth: 1,
    borderColor: "#DEE7E7",
    borderRadius: 8,
    paddingRight: 12,
    paddingLeft: 12,
    marginBottom: 16,
    backgroundColor: "#fff",
    color: "#0F1A3D",
  },
  button: {
    justifyContent: "center",
    fontWeight: "bold",
    marginTop: 26,
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 16,
  },
};

export default ResetPassword;
